var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlingo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.75a.31.31 0 01.161.046c.05.03.088.077.113.14l.687 1.706 1.768.162a.31.31 0 01.162.07c.04.036.07.082.09.139a.3.3 0 01-.085.334l-1.34 1.215.404 1.806a.277.277 0 01-.013.185.342.342 0 01-.106.135.301.301 0 01-.154.061.272.272 0 01-.17-.044L12 13.746l-1.517.96a.272.272 0 01-.17.043.301.301 0 01-.154-.06.342.342 0 01-.106-.136.277.277 0 01-.013-.185l.403-1.806-1.34-1.215a.305.305 0 01-.084-.334.347.347 0 01.09-.139.31.31 0 01.162-.07l1.768-.162.687-1.705a.275.275 0 01.113-.141A.31.31 0 0112 8.75z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5a7 7 0 110 14 7 7 0 010-14zm0 1.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17z",
    fill: "currentColor"
  })));
}
SvgSlingo.displayName = 'Slingo';
export default SvgSlingo;